import { usePublicSettings } from '../settings/queries';

export function useWhiteLabel({
  onSuccess,
  enabled = true,
}: { onSuccess?: (value: string) => void; enabled?: boolean } = {}) {
  return usePublicSettings<string>({
    select: (settings) => settings.Whitelabel,
    onSuccess,
    enabled,
  });
}
